var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('network-list',{attrs:{"getParams":_vm.getParams,"hidden-actions":['create'],"hidden-columns":['brand', 'region'],"hidden-filter-options":['brand', 'region', 'cloudaccount'],"id":"NetworkListForCloudregionSidePage"}})}
var staticRenderFns = []

export { render, staticRenderFns }